// This list will remain empty until the new featureKeys for EnvioNube/NuvemEnvio are created in billing
export const NE_PREMIUM_DELIVERY_OPTIONS: string[] = [];
